import { IndianStates, RolesArr, SkillArr } from "Constants/Arrays";
import { FormDataType } from "../../../DataTypes/Form";

export const registrationFormData: () => FormDataType[] = () => {
  return [
    {
      id: "firstName",
      label: "First Name",
      placeholder: "Enter Frist Name",
      boxType: "input-box",
      boxSize: 3,
      type: "text",
      validatetype: "name",
      required: true,
    },
    {
      id: "lastName",
      label: "Last Name",
      placeholder: "Enter Last Name",
      boxType: "input-box",
      boxSize: 3,
      type: "text",
      validatetype: "name",
      required: true,
    },
    {
      id: "address",
      label: "Address",
      placeholder: "Enter Address",
      boxType: "input-box",
      boxSize: 3,
      type: "text",
      validatetype: "acceptAll",
      required: true,
    },
    {
      id: "city",
      label: "City",
      placeholder: "Enter City",
      boxType: "input-box",
      boxSize: 3,
      type: "text",
      validatetype: "acceptAll",
      required: true,
    },
    {
      id: "state",
      label: "State",
      placeholder: "Enter State",
      boxType: "single-select-drop",
      boxSize: 3,
      type: "text",
      validatetype: "acceptAll",
      required: true,
      dropArr: IndianStates,
    },
    {
      id: "postalCode",
      label: "Postal Code",
      placeholder: "Enter Postal Code",
      boxType: "input-box",
      boxSize: 3,
      type: "number",
      validatetype: "acceptAll",
      required: true,
    },
    {
      id: "dob",
      label: "Date Of Birth",
      placeholder: "Enter Date Of Birth",
      boxType: "mui-date",
      boxSize: 3,
      type: "date",
      validatetype: "date",
      required: true,
    },
    // {
    //   id: "description",
    //   label: "Description",
    //   placeholder: "Enter Description",
    //   boxType: "input-box",
    //   boxSize: 3,
    //   type: "text",
    //   validatetype: "acceptAll",
    //   required: true,
    // },
    {
      id: "password",
      label: "Password",
      placeholder: "Choose Password",
      boxType: "input-box",
      boxSize: 3,
      type: "password",
      validatetype: "password",
      required: true,
      showPassword: false,
      hasPasswordToggle: true,
    },
    {
      id: "highestQualification",
      label: "Highest Qualification",
      placeholder: "Enter Highest Qualification",
      boxType: "input-box",
      boxSize: 3,
      type: "text",
      validatetype: "acceptAll",
      required: true,
    },
    {
      id: "roles",
      label: "Roles",
      placeholder: "Select Roles",
      boxType: "multi-select-drop",
      boxSize: 3,
      type: "text",
      validatetype: "dropdown",
      required: true,
      dropArr: RolesArr,
    },
  ];
};

export const skillDataFormArr: FormDataType[] = [
  {
    id: "skills",
    label: "Skill",
    placeholder: "Select Skill",
    boxType: "single-select-drop",
    boxSize: 2,
    validatetype: "dropdown",
    required: true,
    dropArr: SkillArr,
  },
  // {
  //   id: "rating",
  //   label: "Rating",
  //   placeholder: "Enter Rating",
  //   boxType: "input-box",
  //   boxSize: 2,
  //   type: "number",
  //   validatetype: "acceptAll",
  //   required: true,
  //   dropArr: SkillArr,
  // },
  {
    id: "experience",
    label: "Total Experience",
    placeholder: "Enter Total Experience",
    boxType: "input-box",
    type: "number",
    boxSize: 2,
    validatetype: "acceptAll",
    required: true,
    dropArr: SkillArr,
  },
  {
    id: "description",
    label: "Description",
    placeholder: "Enter description",
    boxType: "input-box",
    type: "text",
    boxSize: 2,
    validatetype: "acceptAll",
    required: true,
    dropArr: SkillArr,
  },
  {
    id: "servesPan",
    label: "Serves Pan India",
    placeholder: "Select One Option",
    boxType: "single-select-drop",
    boxSize: 2,
    validatetype: "dropdown",
    required: true,
    dropArr: [
      {
        id: "yes",
        label: "Yes",
        value: "yes",
      },
      {
        id: "no",
        label: "No",
        value: "no",
      },
    ],
  },
  {
    id: "servesState",
    label: "Select State",
    placeholder: "Select States",
    boxType: "multi-select-drop",
    boxSize: 2,
    validatetype: "multi-dropdown",
    required: false,
    dropArr: IndianStates,
  },
];
